module.exports = __webpack_public_path__ + "static/media/guillaume_img.0c56456c.svg";